const moment = require('moment')

module.exports.editorConfig = {
  placeholder: 'Please write something here!',
  toolbar: {
    items: [
      'heading', '|',
      'fontsize', 'fontColor', 'fontBackgroundColor', '|',
      'italic', 'link', '|',
      'bulletedList', 'numberedList', '|',
      'insertTable', 'tableProperties', 'tableCellProperties', 'tableColumn', 'tableRow', 'mergeTableCells', '|',
      'blockQuote', '|',
      'undo', 'redo'
    ],
  }
};

const baseURL = 'https://s3-eu-west-1.amazonaws.com';
module.exports.s3 = {
  baseURL,
};

module.exports.EVENT_TYPE = {
  "all": { name: 'all', text: 'All' },
  "phonecall": { name: 'phonecall', text: 'Phone Call' }, // reminder type => contact-candidate
  "offer": { name: 'offer', text: 'Offer' },
  "interview-arranged": { name: 'interview-arranged', text: 'Interview Arranged' },
  "interview-follow-up": { name: 'interview-follow-up', text: 'Interview Follow-Up' },
  "spec-cv-sent": { name: 'spec-cv-sent', text: 'Spec CV Sent' },
  "bd-call": { name: 'bd-call', text: 'Business Development Call' },
  "cv-sent": { name: 'cv-sent', text: 'CV Sent' },
  "tob": { name: 'tob', text: 'Terms of Business' },
  "in-out": { name: 'in-out', text: 'Ingoing/Outgoing' },
  "bulk-emails": { name: 'bulk-emails', text: 'Bulk Emails' },
  "to-bd": { name: 'to-bd', text: 'To Business Development' },
  "vacancy": { name: 'vacancy', text: 'Vacancy' },
  "to-follow-up": { name: 'to-follow-up', text: 'To Follow-Up' },
  "check-payment": { name: 'check-payment', text: 'Check Payment' }, // reminder type => check-payment
  "send-invoice": { name: 'send-invoice', text: 'Send Invoice' }, // reminder type => send-invoice
};

module.exports.EVENT_TYPE_COLOR = {
  "phonecall": '#40a9ff',
  "offer": '#1e90ff',
  "interview-arranged": '#f759ab',
  "interview-follow-up": '#89cff0',
  "spec-cv-sent": '#b94e48',
  "bd-call": '#c46210',
  "cv-sent": '#ff4d4f',
  "tob": '#8db600',
  "in-out": '#de5d83',
  "bulk-emails": '#ff8c00',
  "to-bd": '#B284BE',
  "vacancy": '#0D98BA',
  "to-follow-up": '#C2B280',
  "check-payment": '#f5222d',
  "send-invoice": '#B284BE',
};

module.exports.COLORS = ['#B0BF1A', '#B284BE', '#72A0C1', '#DE5D83', '#CD7F32', '#FB607F', '#F19CBB', '#008B8B', '#8DB600', '#5F9EA0', '#B94E48', '#0D98BA', '#1E90FF', '#C2B280', '#8C92AC'];

module.exports.PROVIDER = {
  EFINANCIAL: 'efinancial',
};

module.exports.COMPANY = {
  PWC: 'PWC',
  KPMG: 'KPMG',
  SINGAPORE_GOV: 'Singapore Gov'
};

module.exports.FUNCTION = [
  'Advisory',
  'Audit',
  'Tax',
  'N/A'
];

module.exports.refGenerator = (type, number) => {
  const shortInt = type === 'client' ? '1' : '2';
  const date = moment().format('YY-MM-DD').replace(/-/g, "");
  return `LG${shortInt}${date}${number}`;
}

module.exports.uploadFileValidator = (message, file, fileType, fileSize) => {
  const isFileType = fileType.includes(file.type);
  if (!isFileType) {
    message.error(`you can only upload ${fileType} file!`);
  }
  const isLtFileSize = file.size / 1024 / 1024 < fileSize;
  if (!isLtFileSize) {
    message.error(`image must smaller than ${fileSize}MB!`);
  }
  return isFileType && isLtFileSize;
}

module.exports.readFileAsync = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  })
}

module.exports.stripBody = body => {
  const htmlBody = body.replace(/(\r\n|\n|\r|\t+)/gm, '');
  const headTag = htmlBody.match(/<head(.*?)\/head>/);
  if (headTag) {
    return htmlBody.replace(headTag[0], '');
  }
  return body;
}

module.exports.getAvatar = (type, id) => {
  return `${baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/${type}/${id}.jpeg`
}

module.exports.getLocationTimeZone = (location) => {
  switch (location) {
    case 'Singapore':
      return 'Asia/Singapore';
    case 'China':
      return 'Asia/Chongqing';
    case 'UK':
      return 'Europe/London';
    default:
      return null;
  }
};

module.exports.getFinancialYearByDate = (date) => {
  const currentYear = moment(date).year();
  const isAfterFinancial = moment(date).isAfter(`${currentYear}-01-31`);
  return isAfterFinancial ? currentYear : moment(date).subtract(1, 'years').year()
};

module.exports.getFinancialYear = () => {
  const currentYear = moment().year();
  const isAfterFinancial = moment().isAfter(`${currentYear}-01-31`);
  return isAfterFinancial ? currentYear : moment().subtract(1, 'years').year()
};

// TODO: adjust financial date for link-global (01-31 / 01-31)
// TODO: reportPanel line 67 need to change if adjust financial date for link-global
module.exports.buildYearArr = (companyStartYear) => {
  const currentDate = moment().format('YYYY-MM-DD');
  const currentYear = moment().year();
  const isAfterFinancial = moment().isAfter(`${currentYear}-01-31`);

  const startYear = isAfterFinancial ? moment(companyStartYear).subtract(1, 'years').year() : moment(companyStartYear).year();
  const diffYears = moment().diff(moment(startYear, 'YYYY'), 'years');

  const years = []
  for (let i = 0; i < diffYears; i++) {
    const year = moment(companyStartYear, 'YYYY').add(i, 'years').year();
    years.push({
      name: `Financial Year ${year}`,
      type: 'financial-year',
      start: `${year}-01-31`,
      end: `${moment(year, 'YYYY').add(1, 'years').year()}-01-31`,
    });
  }

  return [
    ...[
      { name: 'Current Year', type: 'year', start: `${currentYear}-01-01`, end: `${currentDate}` },
    ],
    ...years,
    ...[
      { name: 'All Time', type: 'all', start: '2022-01-01', end: `${currentDate}` },
    ]
  ];
}
